var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_verify)?_c('div',[(!_vm.deny_order)?_c('success-icon',{attrs:{"text":_vm.verify_status}}):_c('danger-icon',{attrs:{"text":_vm.verify_status}})],1):_c('div',[_c('warning-icon',{attrs:{"text":_vm.verify_status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }